console.log('aaaaaaaaaaaa')
window.addEventListener('DOMContentLoaded',()=>{

const loopSubscriptionInterval = setInterval(()=>{
if(window.hasOwnProperty('loopProps'))
{

    console.log("UCITAO JE LOOP")
    clearInterval(loopSubscriptionInterval)
    injectBenefitsList()

}


},20) 



})


const injectBenefitsList=()=>{
                // Inject HTML after the `.rc-selling-plans` element
                const elementBenefitsNeedToBeInjectedIn=document.querySelector('.loop-subscription-group')
                let htmlToInject = '<ul class="benefit_list active">';
                const benefits=['Happiness 100% guaranteed','Easily manage your subscription','Add, change products, or cancel anytime']

                benefits.forEach(benefit=>{
                    htmlToInject+=`<li><span class="benefit-checkmark">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                    <path d="M6.5 0C2.91571 0 0 2.91571 0 6.5C0 10.0843 2.91571 13 6.5 13C10.0843 13 13 10.0843 13 6.5C13 2.91571 10.0843 0 6.5 0ZM6.5 12.0714C3.42767 12.0714 0.928571 9.57233 0.928571 6.5C0.928571 3.42767 3.42767 0.928571 6.5 0.928571C9.57233 0.928571 12.0714 3.42767 12.0714 6.5C12.0714 9.57233 9.57233 12.0714 6.5 12.0714Z" fill="#222222" fill-opacity="0.7"/>
                    <path d="M5.97712 7.65597L4.1955 6.24136L3.61816 6.96922L6.10225 8.94243L9.4465 5.00204L8.73919 4.40173L5.97712 7.65597Z" fill="#222222" fill-opacity="0.7"/>
                  </svg>
</span> <span class="benefit-text">${benefit}</span></li>`
                })
                /*htmlToInject+=`</ul><p class="benefit_description">Savor the best with Wild Tide Seafoods. From our Wild Alaskan Sockeye Salmon to sweet Snow Crab Clusters to Maine lobster, every bite delivers a taste of coastal perfection. As an American family-owned business led by Captain Chris, we provide wild-caught, sustainably harvested seafood, flash-frozen at sea and delivered fresh via FedEx. No hidden fees, no compromises—just premium seafood ready for easy, restaurant-quality meals at home. Subscribe and save 14%, with full control to adjust or cancel anytime.
                </p>`;*/
                elementBenefitsNeedToBeInjectedIn.insertAdjacentHTML('beforeend', htmlToInject);
}